import React, { useCallback, useEffect, useState } from 'react';
import { validate } from '@nakedplatform/support';

import {
  SquareMeterInput,
  SquareMeterContainer,
  SuperscriptContainer,
  Superscript,
  Regular,
} from './styles';
import { Colors } from 'theme';

/**
 * Renders the square metre component
 *
 * @param props square meter props
 */
export function SquareMeter(props: SquareMeterProps) {
  const { onUpdate, onValidate, defaults, fieldKey, onDefaultButtonVisibility, focusColor } = props;
  const [state, setState] = useState<string>(
    defaults && defaults[fieldKey] ? defaults[fieldKey] : ''
  );

  const handleOnChange = useCallback(value => {
    if (value === '') {
      if (onDefaultButtonVisibility) {
        onDefaultButtonVisibility(true);
      }

      if (onValidate) {
        onValidate(true);
      }
    } else {
      const validation = validate({ value }, { value: 'required|numeric|min:30' });

      if (onDefaultButtonVisibility) {
        onDefaultButtonVisibility(false);
      }

      if (onValidate) {
        onValidate(validation.isValid);
      }
    }

    setState(value);
    if (onUpdate) {
      onUpdate({ ...(value && { [fieldKey]: value }) });
    }
  }, []);

  useEffect(() => {
    handleOnChange(state);
  }, []);
  const [focusBorderColor, setFocusBorderColor] = useState<string>(Colors.alto);
  const handleOnFocus = useCallback(() => {
    setFocusBorderColor(focusColor ?? Colors.green);
  }, [focusColor]);
  const handleOnBlur = useCallback(() => {
    setFocusBorderColor(Colors.alto);
  }, []);

  return (
    <SquareMeterContainer>
      <SquareMeterInput
        keyboardType="numeric"
        placeholder="E.g. 200"
        onChangeText={handleOnChange}
        value={state}
        borderColor={focusBorderColor}
        onFocus={handleOnFocus}
        onBlur={handleOnBlur}
      />
      <SuperscriptContainer>
        <Regular>m</Regular>
        <Superscript>2</Superscript>
      </SuperscriptContainer>
    </SquareMeterContainer>
  );
}
/* Type definitions */
export interface SquareMeterProps {
  /** The default values */
  defaults?: Record<string, string>;
  /** Emits on `onUpdate` event */
  onUpdate?(payload: Record<string, string>): void;
  /** Emits on `onValidate` event */
  onValidate?(isValid: boolean): void;
  /** Emits a value to toggle visibility of default button */
  onDefaultButtonVisibility?(isVisible: boolean): void;
  /** The key to use for emitting component state */
  fieldKey: string;
  /** Which color to wrap inputs in when they are focused */
  focusColor?: string;
}
